import React, { useContext, useEffect, useState } from "react";

import {
  Context,
  fetchStudentTemporaryPasswordList,
  RESET_STUDENT_PASSWORD_SUCCESS,
  resetStudentPassword,
} from "../../../teacherStore";
import StudentTemporaryPasswordList from "../../../templates/teacher/StudentTemporaryPasswordList";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

export default () => {
  const { state, dispatch } = useContext(Context);
  const [calling, peep] = useWaitApiCall(state);

  const assignedClasses = state.teacher.classes.filter(c => !c.is_sub);

  const [classId, setClassId] = useState(assignedClasses[0]?.id);

  const handleResetStudentPassword = (student_id: number) => {
    !calling && dispatch(peep(resetStudentPassword(student_id)));
  };

  useEffect(() => {
    if (state.lastAction === RESET_STUDENT_PASSWORD_SUCCESS && classId) {
      dispatch(peep(fetchStudentTemporaryPasswordList(classId)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, peep, state.lastAction]);

  useEffect(() => {
    classId && dispatch(peep(fetchStudentTemporaryPasswordList(classId)));
  }, [dispatch, peep, classId]);

  return (
    <StudentTemporaryPasswordList
      students={state.student_temporary_password_list}
      classes={assignedClasses}
      classId={classId}
      calling={calling}
      onReissueStudentPassword={handleResetStudentPassword}
      setClassId={setClassId}
    />
  );
};
